import React from 'react';
import Layout from '../../../layout/Layout';

function About() {
  return (
    <Layout>
      <div>About</div>
    </Layout>
  );
}

export default About;
